import React from "react";
import { Link } from "react-router-dom";

export default function NotAuthorized() {
    return (
        <div className="bg-canvas flex min-h-dvh items-center justify-center px-5 py-10">
            <div className="panel w-full max-w-lg p-8 text-center">
                <span className="bg-amber-500/10 ring-amber-500/20 mb-4 inline-flex items-center justify-center rounded-2xl p-3 text-amber-700 ring-1">
                    <i className="bi bi-shield-exclamation text-2xl" />
                </span>
                <h1 className="text-xl font-semibold tracking-tight text-zinc-900">
                    Not Authorized
                </h1>
                <p className="mt-2 text-sm text-zinc-500">
                    Your account does not have access to this page. Please contact your
                    administrator if you believe this is an error.
                </p>
                <Link
                    to="/login"
                    className="border-hairline bg-surface hover:bg-elevated mt-6 inline-flex items-center justify-center gap-2 rounded-xl border px-4 py-2.5 text-sm font-medium text-zinc-700 no-underline transition-colors hover:text-zinc-900"
                >
                    Back to Login
                </Link>
            </div>
        </div>
    );
}
